var React = require('react');

function AngelRoundIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"currentColor","key":0}),React.createElement("g",{"clipPath":"url(#a)","key":1},React.createElement("path",{"d":"M9.29 17.876a.23.23 0 0 0 .13-.12l2.988-6.596.044-.056.045.056 1.375 3.136-1.965.398c-.258.051-.24.337.013.462l3.173 1.593a.554.554 0 0 0 .319.06l2.13-.268c.18-.038.368-.15.372-.332a.396.396 0 0 0-.039-.178l-4.99-10.695s-.24-.215-.433-.215a.494.494 0 0 0-.434.215L6.038 18.14A.41.41 0 0 0 6 18.31a.34.34 0 0 0 .37.34c.095 0 2.92-.773 2.92-.773Z","fill":"#fff"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M6 5h12v13.655H6z"})))]);
}

AngelRoundIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = AngelRoundIcon;

AngelRoundIcon.default = AngelRoundIcon;
